var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoBallPile = function SvgIcoBallPile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M176 168a80 80 0 1 0 80 80 80 80 0 0 0-80-80m224 0a80 80 0 1 0 80 80 80 80 0 0 0-80-80",
    style: {
      opacity: 0.4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 352a80 80 0 1 0 80 80 80 80 0 0 0-80-80M288 0a80 80 0 1 0 80 80 80 80 0 0 0-80-80m0 352a80 80 0 1 0 80 80 80 80 0 0 0-80-80m208 0a80 80 0 1 0 80 80 80 80 0 0 0-80-80",
    className: "ico-ball-pile_svg__fa-primary"
  })));
};
export default SvgIcoBallPile;